<template>
<div>
  <el-upload
    v-if="picUrl === ''"
    :action="actionUrl"
    :limit="1"
    :show-file-list="false"
    :http-request="fnUploadRequest">
    <el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button> &nbsp;
    <!-- <span slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</span> -->
  </el-upload>
  <el-row v-else>
    <el-image style="width: 175px;height: 75px;" fill="scale-down" :src="picUrl"></el-image> &nbsp;
    <el-button size="small" type="text" @click="resetFn">重新上传</el-button>
  </el-row>

</div>
</template>

<script>
  import {Message} from "element-ui";
    export default {
      name: "picUpload",
      props: {
        picUrl:{
          type: String,
          default: ''
        }
      },
      data() {
        return {
          actionUrl: this.$apiUrl + "/util/upload/picFile",
          downloadUrl:''
        }
      },
      methods: {
        fnUploadRequest(f) {
          var _this = this;
          var param = new FormData(); //创建form对象
          param.append('file', f.file);//通过append向form对象添加数据
          var xhr = new XMLHttpRequest();
          xhr.open("post", f.action, true);
          xhr.setRequestHeader("authorization",_this.$store.state.user ? _this.$store.state.user.token : null);
          xhr.onload = function () {
            _this.downloadUrl = JSON.parse(xhr.response).result.url;
            _this.$emit('getUrl', _this.downloadUrl)
            _this.$message({
              message: '上传成功!',
              type: 'success'
            });
          };
          xhr.send(param);
          xhr.onreadystatechange = function(){
            if(xhr.status == 401){
              window.location.href = "/";
            }else if(xhr.status != 200){
              console.log(xhr)
              Message.error(xhr.statusText)
            }

          }
        },
        // 重新上传图片
        resetFn() {
          this.$emit('getUrl',"")
        }
      }
    }
</script>

<style lang="scss" scoped>
.img-box{
  width: 100%;
  height: 110px;
  line-height: 180px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;
}
@media screen and (max-width: 768px) {
  .el-upload {
    width: 100%;
  }
  ::v-deep .el-upload .el-upload-dragger {
    width: 100%!important;
  }
}
</style>
